<template>
    <div>
        <div class="loader" v-images-loaded="onImageLoad">
            <template v-for="project in projects.slice(0, 6)">
                <img :src="project.image" :key="project._id">
                <!-- <img :src="project.image.color">
                <img :src="project.image.bw"> -->
            </template>
        </div>
        <div class="index" ref="index">
            <Navigation />
        </div>
        <a @click="onFixedArrowClick" class="fixed-arrow"></a>
        <div class="container">
            <div class="container__center">
                <div class="projects__container">
                    <h1>Projects</h1>
                    <!-- <div class="projects-mobile-header">
                        <select class="projects-mobile-header__select" v-model="actualSection">
                            <option v-bind:value="'all'">
                                {{ $t('all_projects') }}
                            </option>
                            <option v-for="section in sections" v-bind:value="section._id">
                                {{ section.name }}
                            </option>
                        </select>
                        <div class="projects-mobile-header__center">
                            <div class="projects-mobile-header__label">{{ sectionName }} &#9662;</div>
                        </div>
                        
                    </div> -->
                    <div class="project-filters">
                        <a :class="`project-filters__item _first ${actualSection === 'all' ? 'isActive' : ''}`"
                            @click.prevent="onSetSection('all')">{{ $t('section_all') }}</a>
                        <a v-for="section in sections"
                            :class="`project-filters__item ${actualSection === section._id ? 'isActive' : ''}`"
                            @click.prevent="onSetSection(section._id)" :key="section._id">{{ section.name }}</a>
                    </div>
                    <div class="projects" :class="`projects--${listType}`" v-if="showItems">
                        <router-link v-for="( project, index ) in actualProjects"
                            :to="{ name: 'project', params: { projectSlug: project.slug } }"
                            @click.native.prevent="onFollowLink({ name: 'project', params: { projectSlug: project.slug } })"
                            :key="project._id" :event="''"
                            :class="`a-link projects__item ${getProjectClass(index)} projects__item--${listType} showAnimetion`">
                            <div class="projects__image" :class="`projects__image--${project.gridType || 'common'}`">
                                <div class="projects__image-inner _color"
                                    :style="`background-image: url(${project.image})`"></div>
                                <div class="projects__image-inner _bw" :style="`background-image: url(${project.image})`">
                                </div>
                            </div>
                            <div class="projects__content">
                                <div class="projects__title">{{ project.title }} </div>
                                <div class="projects__desc">{{ project.type }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { globalMixin, pageArrowMixin } from '../mixins'
import Vue from 'vue'
import _ from 'lodash'
import Navigation from '../components/Navigation.vue'


export default {
    mixins: [globalMixin, pageArrowMixin],

    props: ['activeSection'],

    components: {
        Navigation,
    },

    data() {
        return {
            actualSection: false,
            listType: 'list',
            showItems: false,
            sections: [
                {
                    _id: 'architecture',
                    name: Vue.i18n.translate('section_architecture'),
                },
                {
                    _id: 'design',
                    name: Vue.i18n.translate('section_design'),
                },
                // {
                //     _id: 'landscape',
                //     name: Vue.i18n.translate('section_landscape'),
                // },
            ],
            projects: [],
        }
    },

    computed: {
        sectionName() {
            const result = this.sections.find(sec => sec._id === this.actualSection);
            return result ? result.name : this.$t('all_projects');
        },
        actualProjects() {
            const section = this.actualSection
            let list = this.projects;
            if (section !== 'all') {
                list = _.filter(this.projects, project => _.includes(project.sections, section))
            }
            if (this.listType !== 'grid') return list.map(el => { el.gridType = 'common'; return el });
            let columns = [[], []];
            list.forEach((el, i) => {
                if (i % 2 === 0) {
                    columns[0].push(el);
                } else {
                    columns[1].push(el);
                }
            });
            columns[0] = columns[0].map((el, i) => {
                el.gridType = 'common'
                if ([0, 2, 6, 8, 12, 14, 18, 20, 24, 26, 30, 32, 36, 38].includes(i)) {
                    el.gridType = 'A'
                }
                if ([4, 10, 16, 22, 28, 34, 40].includes(i)) {
                    el.gridType = 'C'
                }
                return el;
            });
            columns[1] = columns[1].map((el, i) => {
                el.gridType = 'common'
                if ([3, 5, 9, 11, 15, 17, 21, 23, 27, 29, 33, 35, 39, 41].includes(i)) {
                    el.gridType = 'A'
                }
                if ([1, 7, 13, 19, 25, 31, 37, 43].includes(i)) {
                    el.gridType = 'C'
                }
                return el;
            });
            return _.concat(columns[0], columns[1]);
        }
    },

    methods: {
        onSetSection(section) {
            this.$router.push({ name: 'projects', params: { activeSection: section } })
        },

        // getGridTypeClass( index ) {
        //     const gridIndex = index - parseInt( ( index - 1 ) / 9 ) * 9
        //     if (this.listType !== 'grid') return;
        //     // if ([0, 4, 7, 11, 15, 19, 23].includes(gridIndex)) return '1'
        //     // if ([3, 8, 13, 18, 24].includes(gridIndex)) return '2'
        //     // if ([0, 2, 9, 11, 15].includes(gridIndex)) return '1'
        //     // if ([4, 7, 12, 18].includes(gridIndex)) return '2'
        //     return 'comon';
        // },

        getProjectClass(index) {
            const gridIndex = index - parseInt((index - 1) / 9) * 9

            if ([0, 3, 4, 5, 7, 9].includes(gridIndex)) {
                return '_n3'
            }
            else if ([1, 6, 10].includes(gridIndex)) {
                return '_n2'
            }
            else {
                return '_n1'
            }
        },

        setProjects(data) {
            this.projects = data
        },
    },

    created() {
        this.actualSection = this.activeSection
    },

    mounted() {
        this.$http.get(this.getApiURL(`getProjectsList?lang=${Vue.i18n.locale()}`)).then((response) => {
            this.setProjects(response.data)
        })
        this.$store.commit('setNavigationColor', 'black')
        this.$store.commit('setLogoColor', 'black')
        setTimeout(() => {
            this.showItems = true
        }, 100)
    },

    watch: {
        activeSection() {
            this.actualSection = this.activeSection
        },
        actualSection() {
            this.$router.push({ name: 'projects', params: { activeSection: this.actualSection } })
        }
    },
}
</script>

<style lang="scss">
@import '../assets/vars.scss';

.projects-mobile-header {
    text-align: center;
    position: absolute;
    width: 100%;
    top: rem(19px);

    &__select {
        appearance: none;
        background: none;
        border: none;
        font-size: rem(18px);
        line-height: rem(24px);
        font-weight: 500;
        color: #303030;
        text-align: center;
        text-align-last: center;

        option {
            text-align: left;
        }
    }

    &__center {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        background: white;
        z-index: 1;
    }

    &__label {
        font-size: rem(18px);
        line-height: rem(24px);
        font-weight: 500;
        color: #303030;
        text-align: center;
    }
}

.projects-list-style {
    display: none;

    @media #{$mb} {
        display: flex;
        justify-content: center;
        padding-top: rem(62px);
    }

    &__button {
        display: block;
        line-height: 0;
        margin: 0 rem(9px);
        opacity: 0.1;

        &--active {
            opacity: 1;
        }
    }
}

.project-filters {
    font-family: 'Didot';
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 110%;
    letter-spacing: -0.02em;
    margin-top: 60px;
    display: flex;
    gap: 54px;

    .project-filters__item {
        opacity: 0.3;
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
          opacity: 1;  
        }
    }

    .project-filters__item.isActive {
        opacity: 1;
    }
    @media #{$mb} {
        flex-wrap: wrap;
        font-size: rem(26px);
        gap: 30px;
        margin-top: 30px;
    }

    &--mobile-hide.project-filters {
        @media #{$mb} {
            display: none;
        }
    }
}

.projects__container {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    max-width: 1325px;
    padding: rem(140px) rem(150px) 0;
    padding-left: rem(50px);
    padding-right: rem(calc(50px - 1em));

    h1 {
        margin: 0;
        padding: 0;
        font-family: 'Didot';
        font-style: normal;
        font-weight: 400;
        font-size: 70px;
        line-height: 120%;
        display: block;
        width: 100%;

        @media #{$mb} {
            white-space: normal;
            font-size: rem(50px);
            letter-spacing: 0.05em;
        }
    }

    @media #{$mb} {
        margin: 0;
        padding: 0;
        padding-top: rem(80px);
        padding-left: rem(20px);
        padding-right: rem(20px);
    }
}

.projects {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 26px 20px;
    margin-top: 60px;

    @media #{$mb} {
        grid-template-columns: 1fr 1fr;
        gap: 20px 10px;
        margin-top: 30px;
        &--grid {
            display: block;
            column-count: 2;
            column-gap: 0;
        }
    }
}

.projects__item {
    display: block;
    text-decoration: none;
    margin-bottom: rem(39px);
    box-sizing: border-box;
    overflow: hidden;

    @media #{$mb} {
        margin-bottom: rem(20px);
    }

    // &._n1 {
    //     width: 100%;
    // }

    // &._n2 {
    //     width: 66.6666%;
    // }

    // &._n3 {
    //     width: 33.3333%;
    // }

    &:hover {
        .projects__image-inner {

            &._color {
                opacity: 1;
            }
        }
    }

    @media #{$mb} {
        width: 100% !important;

        &--grid {
            width: rem(100%) !important;
            break-inside: avoid;
            padding: rem(0 9px);
        }
    }
}

.projects__image {
    position: relative;
    height: rem(360px);

    @media #{$mb} {
        height: rem(160px);

        &--A {
            height: rem(220px);
        }

        &--C {
            height: rem(280px);
        }
    }
}

.projects__image-inner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background: {
        size: cover;
        position: center;
    }

    ;
    transition: all .5s ease;

    &._bw {
        opacity: 1;
    }

    &._color {
        opacity: 0;
        z-index: 1;
    }

    @media #{$mb} {

        &._color {
            opacity: 1;
        }
    }
}

.projects__content {
    margin-top: rem(21px);

    @media #{$mb} {
        margin-top: rem(8px);
    }
}

.projects__title {
    position: relative;
    font-family: 'Didot';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 120%;
    letter-spacing: -0.02em;
    padding-bottom: 1px;
    display: inline;
    background-image: linear-gradient(rgba(38, 38, 38, 1), rgba(38, 38, 38, 1));
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 0% 1px;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 9px;
    transition: background-size 0.2s;
    text-decoration-color: rgba(38, 38, 38, 0.1);

    @media #{$mb} {
        font-size: rem(12px);
        line-height: rem(14px);
        letter-spacing: 0.5px;
        font-weight: normal;
        text-decoration: none;
    }
}

.title__line {
    position: absolute;
    top: 2px;
    left: 0px;
	font-family: 'Didot';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 110%;
    letter-spacing: -0.02em;
    display: inline;
    background-image: linear-gradient(rgba(38, 38, 38, 1), rgba(38, 38, 38, 1));
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 100% 1px;
    transition: background-size 0.2s;

    @media #{$mb} {
        font-size: rem(12px);
        line-height: rem(14px);
        letter-spacing: 0.5px;
        font-weight: normal;
    }
}

// .projects__title::after {
// 	content: '';
// 	position: absolute;
// 	bottom: 0px;
// 	left: 0;
// 	width: 0px;
// 	height: 1px;
// 	background: #303030;
//     opacity: 1;
// 	transition: width 0.2s;
// }

.projects__item:hover .projects__title,
.projects__item:focus .projects__title {
    background-size: 100% 1px;
    @media #{$mb} {
        background-size: 0% 1px;
    }
}

.projects__desc {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    margin-top: 5px;

    @media #{$mb} {
        display: none;
    }
}

.showAnimetion {
    animation: showAnimation 0.5s;
}

@keyframes showAnimation {
    from {
        opacity: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

</style>
